module.exports = __webpack_public_path__ + "static/media/photo-editor-page-3.03d84329.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Features/assets/photo-editor-page-3.jpg
// module id = 1418
// module chunks = 0